import type {ReactElement} from 'react';
import {useRouteError} from 'react-router-dom';
import {Trans} from '@lingui/macro';
import styles from './index.module.scss';

export default function Error(): ReactElement {
    const error = useRouteError() as Error;

    return (
        <div id="error-page" className={styles.root}>
            <h1 className={styles.title}>
                <Trans>Oops!</Trans>
            </h1>
            <p className={styles.description}>
                <Trans>Sorry, an unexpected error has occurred.</Trans>
            </p>
            <p className={styles.error}>
                <i>{error.message}</i>
            </p>
        </div>
    );
}
